module.exports = __webpack_public_path__ + "img/favorite-white.de3a590b.svg";